import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_PATCH } from '../../constants/api';
import { setPrinterTasks } from './getPrinterTasks';

const patchPrinterTasks = createAsyncThunk('printer/patchPrinterTasks',
  async ({ id, ...form }, { rejectWithValue, dispatch }) => {
    try {
      const data = await authSet(METHOD_PATCH, `/printer/tasks/${id}`, form);
      dispatch(setPrinterTasks(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchPrinterTasks;
